import { render, staticRenderFns } from "./WidgetActive.vue?vue&type=template&id=23719817&scoped=true&"
import script from "./WidgetActive.vue?vue&type=script&lang=js&"
export * from "./WidgetActive.vue?vue&type=script&lang=js&"
import style0 from "./WidgetActive.vue?vue&type=style&index=0&id=23719817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23719817",
  null
  
)

export default component.exports